/**
 * Quick Quote app: move #quote-error-messages from below the form to the top
 * (after "Fields marked * are required.") so validation errors are visible without scrolling.
 */
(function () {
  if (!/\/apps\/request-quote/i.test(window.location.pathname)) return;

  var rafScheduled = false;

  function placeQuoteErrorMessages() {
    var err = document.getElementById('quote-error-messages');
    var form = document.querySelector('#pnl-request-quote-wrapper .quote-form');
    if (!err || !form || !form.contains(err)) return;

    var anchor = form.querySelector('.quote-required-message');
    if (anchor) {
      if (anchor.nextElementSibling !== err) {
        anchor.insertAdjacentElement('afterend', err);
      }
      return;
    }

    var firstGroup = form.querySelector('.quote-input-group');
    if (firstGroup && firstGroup.previousElementSibling !== err) {
      firstGroup.insertAdjacentElement('beforebegin', err);
    }
  }

  function schedulePlace() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      placeQuoteErrorMessages();
    });
  }

  function init() {
    placeQuoteErrorMessages();
    var root = document.getElementById('pnl-request-quote-wrapper');
    if (!root) {
      var boot = new MutationObserver(function () {
        if (document.getElementById('pnl-request-quote-wrapper')) {
          boot.disconnect();
          attachObserver();
          schedulePlace();
        }
      });
      boot.observe(document.body, { childList: true, subtree: true });
      return;
    }
    attachObserver();
  }

  function attachObserver() {
    var root = document.getElementById('pnl-request-quote-wrapper') || document.body;
    var obs = new MutationObserver(schedulePlace);
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
